export enum LcgQuoteBacktestStatus {
  Running = "running",
  Completed = "completed",
  Failed = "failed",
}
